import AppDataService from "./AppDataService";

const COMMON_BASE = "auth";

export default class UnsignedVisitService {
  static async getVisitNoteList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchKey ? "name=" + data?.searchKey : "",
      data?.status ? `isVisitSign=${data.status}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`visit-note${queryString}`);
  }
}
